// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__3LSuQ","logo-img":"Header_logo-img__2MN-i"};